import moment from 'moment';

/**
 * Formats a date whilst not changing the timezone
 * @param {string} utc Requires utc string time
 */
export default function utcStringToEpoch(utc) {
  return moment.parseZone(utc).valueOf();
}
